import { useQuery } from '@tanstack/react-query';
import assistantService from '@services/assistant';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const MY_ASSISTANT_CONVERSATIONS_QUERY_KEY = 'myAssistantConversations';

/**
 * Sprint 37, story-196. Feeds the Assistant page's left rail. Refetches on window focus and every
 * few seconds while any row is still `THINKING`, so an inferred title (story-197) replaces the
 * truncated one in place without a manual refresh.
 */
export const useMyAssistantConversations = () => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [MY_ASSISTANT_CONVERSATIONS_QUERY_KEY, organizationId],
    queryFn: () => assistantService.getMyAssistantConversations(),
    enabled: !!organizationId,
    refetchOnWindowFocus: true,
    refetchInterval: (query) => (query.state.data?.some((c) => c.status === 'THINKING') ? 3000 : false),
  });
};

export default useMyAssistantConversations;
